import { Button, Form, Input, message, Select, Space } from "antd";
import React, { useState } from "react";
import _t from "../../lang/translate";
import { acceptValidation } from "../../services/leasingService";
import { AcceptValidationType } from "../../types/leasingTypes";
import { OpenModalProps } from "../../types/modalTypes";
import assertFC from "../../utilities/assertFC";
import { renderErrorMessage } from "../messages/errorMessage";
import EnumSelect from "../form/enumSelect";

const { TextArea } = Input;

export default function AcceptLeasingCase<T extends object>({ onSuccess, onCancel, payload }: OpenModalProps<T>) {
  const [tmpForm] = Form.useForm<AcceptValidationType>();
  const [loading, setLoading] = useState<boolean>(false);
  const handleAccept = async (values: any) => {
    const { id } = payload;
    try {
      setLoading(true);
      const { data } = await acceptValidation(id, values);
      onSuccess(data as T);
    } catch (error) {
      renderErrorMessage(error)
      setLoading(false);
    }
  };

  return (
    <Form form={tmpForm} requiredMark={false} layout="horizontal" onFinish={handleAccept} initialValues={{}}>
      <h2 className="modal-title">{_t("accept", "case")}</h2>
      <Form.Item labelCol={{ span: 24 }} rules={[{ required: true, message: "Dette felt er påkrævet!" }]} name="note" label={_t("note")}>
        <TextArea />
      </Form.Item>
      <Form.Item labelAlign="left" name="riskAssessment" label={_t("riskClassification")} rules={[{ required: true }]}>
        <EnumSelect nameKey={['leasingCase', 'riskAssessment']} />
      </Form.Item>
      <div className="text-right">
        <Space>
          <Button type="ghost" onClick={onCancel} disabled={loading}>
            {_t("cancel")}
          </Button>
          <Button htmlType="submit" loading={loading} type="primary">
            {_t("accept")}
          </Button>
        </Space>
      </div>
    </Form>
  );
}

assertFC(AcceptLeasingCase);
